/** Private, current-turn execution data; never serialize this object into a tool result. */
export interface HeadlessExecutionContext {
  turnId: string
  accountId: string
  strategyId: string
  executionId: string
  result: Record<string, unknown>
}

let current: HeadlessExecutionContext | null = null

export function setHeadlessExecutionContext(context: HeadlessExecutionContext): void {
  current = context
}

export function getHeadlessExecutionContext(
  turnId: string | undefined,
  accountId: string | undefined,
  executionId: string,
): HeadlessExecutionContext | null {
  return current &&
    current.turnId === turnId &&
    current.accountId === accountId &&
    current.executionId === executionId
    ? current
    : null
}

export function clearHeadlessExecutionContext(turnId?: string): void {
  if (!turnId || current?.turnId === turnId) current = null
}
